export default "__VITE_ASSET__Bmyg_$aP__"